export enum VehicleAccess {
  All = 'all',
  Selected = 'selected',
}

// Base form data shared between add and edit
export type UserFormData = {
  firstName: string;
  lastName: string;
  email: string;
  auth0RoleId: string;
};

export type EditUserFormData = UserFormData & {
  vehicleAccess: VehicleAccess;
  vehicleIds?: Array<string>;
};

export type AddUserFormData = UserFormData;
